import React from 'react';
import { injectIntl } from 'react-intl';
import { stage_promotion_types as spt } from '../data/bootstrap_stages';

import { TeamPublicShare } from './TeamClient';
import { PhotoFunPublicShare } from '../components/front/PhotoFunStage';

import BattleShare from '../components/front/BattleShare';
import PickFavoriteShare from '../components/front/PickFavoriteShare';
import LikeDislikeShare from '../components/front/LikeDislikeShare';
import OneTimeBracketShare from '../components/front/OneTimeBracketShare';

const ShareParticipation = (props) => {
	const promotion = props?.promotion?.Promotion ?? {};
	const user = props?.user?.User ?? {};
	const stage = props?.stage?.Stage ?? {};

	const promo_type_id = parseInt(stage.promotion_type_id);
	
	let Component = false;
	let extra_props = {};

	switch(promo_type_id) {
		case spt.PHOTOFUN.id:
		case spt.SCENES.id:
			Component = PhotoFunPublicShare;
			break;

		case spt.TEAM.id:
			Component = TeamPublicShare;
			break;

		case spt.FACEOFF.id:
			Component = BattleShare;
			break;

		case spt.PICK_FAVORITE.id:
			Component = PickFavoriteShare;
			break;

		case spt.LIKEDISLIKE.id:
			Component = LikeDislikeShare;
			break;

		case spt.BRACKET_PREDICTOR.id:
			Component = OneTimeBracketShare;
			break;
	}

	if([spt.FACEOFF.id, spt.PICK_FAVORITE.id].includes(promo_type_id) && props?.data?.stats != undefined) {
		//extra_props.stats = props.data.stats;
	}

	if(Component === false) return null;

	return (
		<div class="flex_cols">
			<div class="flex_col col_2">
				<Component
					{...extra_props}
					promotion={promotion}
					stage={stage}
					user={user}
					intl={props.intl}
				/>
			</div>
		</div>
	)
}

export default injectIntl(ShareParticipation);